// Generated by purs version 0.15.0
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Restaumatic_Orders_Checkout_Types_ExtraDiscount from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
var toDetails = function (v) {
    return function (v1) {
        return {
            name: v.name,
            prize: v.prize,
            value: (function () {
                if (v.prize instanceof Restaumatic_Orders_Checkout_Types_ExtraDiscount.PriceDiscount) {
                    return Data_Ord.min(Data_Money_Rounded.ordMoney)(v1.totalAfterPromotions)(v.prize.value0);
                };
                if (v.prize instanceof Restaumatic_Orders_Checkout_Types_ExtraDiscount.PercentageDiscount) {
                    return Data_Money_Rounded.scaleByPercentAndRound(Data_Int.toNumber(v.prize.value0))(v1.totalAfterPromotions);
                };
                throw new Error("Failed pattern match at Restaumatic.Cart.ExtraDiscount (line 25, column 7 - line 29, column 86): " + [ v.prize.constructor.name ]);
            })()
        };
    };
};
export {
    toDetails
};
export {
    ExtraDiscount,
    PercentageDiscount,
    PriceDiscount
} from "../Restaumatic.Orders.Checkout.Types.ExtraDiscount/index.js";
//# sourceMappingURL=index.js.map
